module.exports = __webpack_public_path__ + "img/appstore.33528281.png";